
import Resolution from "engine/Resolution.js";
import {setSelectedPianoRollSteps} from 'actions/index.js';

const RESOLUTION = new Resolution(32, false);

export const spread = (track, steps, stepNumbers, amount) => {
    let firstStepData = getFirstStep(stepNumbers);

    let copiedSteps = steps.map(x => x.getCopy(true, false));

    // for each step calculate the distance between the
    // step number & the first step number.

    // calculate new location by multiplying by amount
    // firs delette steps
    let pattern = track.getEasyPattern();
    pattern.deleteSteps(steps);

    let newSteps = [];
    let i=0;

    for (let [stepData, stepNumber] of stepNumbers) {
        let transpose = stepData.transpose;
        let newTranspose  =
            transpose + Math.ceil(i * amount);
        let position = stepNumber - Math.floor(stepNumber);
        copiedSteps[i].transpose = newTranspose;

        pattern.addStep(
            copiedSteps[i],
            Math.floor(stepNumber),
            RESOLUTION,
            position);
        newSteps.push(
            copiedSteps[i]);
        
        i++;
    }
        
    track.updateSteps(true);

    track.sequencerEngine.dispatch(
        setSelectedPianoRollSteps(newSteps));
    return newSteps;
};

const getFirstStep = (stepNumbers) => {
    let minStepData ;
    let minStepNumber=Infinity;
    for (let [stepData, stepNumber] of stepNumbers) {
        if (minStepNumber > stepNumber) {
            minStepNumber = stepNumber;
            minStepData = stepData;
        }
    }
    return minStepData;
};
